import { render, staticRenderFns } from "./PhotoBookImageList.vue?vue&type=template&id=8bd17650&scoped=true"
import script from "./PhotoBookImageList.vue?vue&type=script&lang=js"
export * from "./PhotoBookImageList.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookImageList.vue?vue&type=style&index=0&id=8bd17650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd17650",
  null
  
)

export default component.exports